import '../sass/app.scss'
import lozad from 'lozad'
// import Swiper from 'swiper';
// import {Navigation, Pagination, Autoplay} from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import Inputmask from 'inputmask';


document.addEventListener('DOMContentLoaded', () => {

    const observer = lozad();
    observer.observe();

});